import { useLogout } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { LoadingSpinner } from "components/LoadingSpinner/";

/**
 * Handles IdP-initiated (front-channel) logout.
 * When a user logs out from their IdP (Okta, Azure AD, etc.),
 * the IdP redirects to this page to terminate the Libertify session.
 */
export const SsoLogoutPage = () => {
  const { mutate: logout } = useLogout();
  const navigate = useNavigate();

  useEffect(() => {
    logout(undefined, {
      onSuccess: () => navigate("/login"),
      onError: () => navigate("/login"),
    });
  }, []);

  return <LoadingSpinner />;
};
